import {ColDef, ValueGetterParams} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewBooleanColumn extends AbsAGGridEditViewColumn
{
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = 'agCheckboxCellRenderer';
    colDef.cellEditor = 'agCheckboxCellEditor';
    colDef.valueGetter = (params: ValueGetterParams) => {
      const valueAsBooleanOrString: boolean | string = this.getValue(params.data);
      let parsedValue: boolean;
      if (ObjectChecker.isString(valueAsBooleanOrString))
        parsedValue = JSON.parse(valueAsBooleanOrString)
      else
        parsedValue = valueAsBooleanOrString;
      return Boolean(parsedValue);
    }
    return [colDef];
  }
}
